/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Apply share dialog data and set the state
 *
 * @param  {Object} state
 * @param  {Object} project
 * @return {Void}
 */
const SET_SHARE_DIALOG = (state, project) => {
    state.project = project
    state.showDialog = true
}

/**
 * Reset the shared project state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_SHARED_PROJECT = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Reset the share dialog and state parameters
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_SHARE_DIALOG = (state) => {
    state.project = {}
    state.showDialog = false
    state.form.successMessage = null
    state.form.email = ''
    state.form.level = null
    state.form.pending = false
    state.link.pending = false
    state.link.url = null
    state.link.pin = null
}

/**
 * Set the share form email
 *
 * @param  {Object} state
 * @param  {String} email
 * @return {Void}
 */
const SET_SHARE_EMAIL = (state, email) => {
    state.form.email = email
}

/**
 * Set the share form level
 *
 * @param  {Object} state
 * @param  {Number} level
 * @return {Void}
 */
const SET_SHARE_LEVEL = (state, level) => {
    state.form.level = level
}

/**
 * Reset the share form
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_SHARE_FORM = (state) => {
    state.form.successMessage = null
    state.form.email = ''
    state.form.level = null
    state.form.pending = false
}

/**
 * Handle successful project share request
 *
 * @param  {Object} state
 * @return {Void}
 */
const PROJECT_SHARED_FAILURE = (state, err) => {
    state.form.error = err.response.data
    state.form.pending = false
}

/**
 * Set the share form submission state
 *
 * @param  {Object} state
 * @return {Void}
 */
const SUBMIT_SHARE_FORM = (state) => {
    state.form.pending = true
}

/**
 * Handle successful project share request
 *
 * @param  {Object} state
 * @return {Void}
 */
const PROJECT_SHARED_SUCCESS = (state, message) => {
    state.form.successMessage = message
    state.form.pending = false
}

const CREATE_LINK = (state) => {
    state.link.pending = true
}

/**
 * Set the successful link generation state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const CREATE_LINK_SUCCESS = (state, payload) => {
    state.link.pending = false
    state.link.url = payload.url
    state.link.pin = payload.pin
}

/**
 * Set the failed link generation state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const CREATE_LINK_FAILURE = (state, payload) => {
    state.link.pending = false
    state.link.url = null
    state.link.pin = null
}

const REMOVE_ERROR_MESSAGE = (state) => {
    state.form.error = null
}

export default {
    CREATE_LINK,
    RESET_STATE,
    SET_SHARE_EMAIL,
    SET_SHARE_LEVEL,
    RESET_SHARE_FORM,
    SET_SHARE_DIALOG,
    SUBMIT_SHARE_FORM,
    RESET_SHARE_DIALOG,
    CREATE_LINK_SUCCESS,
    CREATE_LINK_FAILURE,
    RESET_SHARED_PROJECT,
    PROJECT_SHARED_FAILURE,
    PROJECT_SHARED_SUCCESS,
    REMOVE_ERROR_MESSAGE
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/share/mutations.js